import {
  HttpContextToken,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest
} from '@angular/common/http';
import {inject} from '@angular/core';
import {LoadingIndicatorService} from '../service/loading-indicator.service';
import {catchError, finalize, Observable} from 'rxjs';

/**
 * @constant
 * @description This token denotes whether to skip the loading-indicator indicator for an HTTP request or not.
 * @name SkipLoadingIndicator
 * @type {HttpContextToken<boolean>}
 */
export const SkipLoadingIndicator: HttpContextToken<boolean> = new HttpContextToken<boolean>(() => false);

/**
 * @constant
 * @description This constant provides an interceptor to handle loading-indicator indicators for HTTP requests.
 * @name LoadingInterceptorFn
 * @export
 * @param {HttpRequest<any>} httpRequest The HTTP request to intercept.
 * @param {HttpHandlerFn} next The next handler in the chain.
 * @returns {Observable<HttpEvent<any>>} The observable of the HTTP event.
 * @type {HttpInterceptorFn}
 */
export const LoadingInterceptorFn: HttpInterceptorFn = (httpRequest: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {

  // Inject our loading-indicator service.
  const loadingService: LoadingIndicatorService = inject(LoadingIndicatorService);

  // Check for a custom attribute to skip the loading-indicator indicator then pass the request directly to the next handler.
  if (httpRequest.context.get(SkipLoadingIndicator)) return next(httpRequest);

  // Turn on the loading-indicator indicator.
  loadingService.start();

  // Pass the request to the next handler and turn off the loading-indicator indicator when the request is complete.
  return next(httpRequest).pipe(catchError(e => {

    // Pass the error the the loading-indicator indicator event handler.
    loadingService.error(e);

    // Rethrow the error.
    throw e;

  }), finalize(() => loadingService.complete()));
};
